import { Flex } from 'antd';
import { RefObject } from 'react';
import { useNavigate } from 'react-router';

import { ActionButton } from '@/pages/UserAccount/UserRequests/ui';

import { Button, ButtonSizes, ButtonVariant, Modal, Typography } from '@/shared/ui';

export const AgeWarningModal: React.FC<{
  isModalOpen: boolean;
  closeModal: () => void;
  deleteDraft: (requestId: string) => Promise<void>;
  requestId: string;
  goBackRef: RefObject<string>;
}> = ({ isModalOpen, closeModal, deleteDraft, requestId, goBackRef }) => {
  const navigate = useNavigate();

  const handleCancelDraft = async (): Promise<void> => {
    try {
      await deleteDraft(requestId);
      closeModal();
      navigate(goBackRef.current);
    } catch (error) {
      console.error(error);
      navigate(goBackRef.current);
    }
  };

  return (
    <Modal
      open={isModalOpen}
      size="md"
      centered
      title="Послуги доступні користувачам з 14 років"
      onCancel={closeModal}
      maskClosable={false}
      closable={false}
      footer={
        <Flex gap={12}>
          <Button onClick={closeModal} variant={ButtonVariant.PRIMARY}>
            Повернутись і виправити
          </Button>
          <ActionButton
            onClick={handleCancelDraft}
            buttonVariant={ButtonVariant.SECONDARY}
            size={ButtonSizes.LG}
            iconName={null}
          >
            Скасувати створення запиту
          </ActionButton>
        </Flex>
      }
    >
      <Typography as="p">
        Якщо ви вказали помилкову дату, ви можете повернутись і виправити її.
        <br />
        Наголошуємо, що в разі вказання фіктивної дати народження, ви не отримаєте витяг.
      </Typography>
    </Modal>
  );
};
